/*
 *   DEPRECATED: The purpose of this file initially was for Backbone template helpers and the file includes Backbone
 *   dependencies. If possible, avoid using anything/adding anything in this file and instead add the utility
 *   functions to app/utils/{your_file}.js
 * */

// Dependencies
var _ = require('underscore');
var Radio = require('backbone.radio');
var moment = require('moment');
var numeral = require('numeral');
var linkify = require('linkifyjs/string');
var slugify = require('underscore.string/slugify');

// Channels
var channel = Radio.channel('global');

// Global Template Helpers
// --------------------------------
// For global use only! For helpers specific to individual views, see Marionette's templateHelpers

var STATIC_URL = function () {
    return (
        channel.request('config:pick', 'STATIC_URL') ||
        'http://' + window.location.hostname + ':' + window.location.port
    );
};

var BASE_URL = function () {
    return channel.request('config:pick', 'BASE_URL');
};

var _makeOptionsHelper = function (choices) {
    var template = _.template('<option value="<%= val %>"><%= label %></option>');
    var options = [];

    _.each(choices, function (choice) {
        var option = template(choice);
        options.push(option);
    });

    return options.join('\n');
};

var globalHelpers = {
    abbreviateBathroom: function (label) {
        return label.replace('Bathroom', 'BATH');
    },

    abbreviateLayout: function (label) {
        return label.replace('Bedroom', 'BR').replace('Junior', 'JR');
    },

    staticPath: function (filePath) {
        var staticPath = STATIC_URL() + 'archer/dist/assets/';
        return staticPath + filePath;
    },

    rootStaticPath: function (filePath) {
        return STATIC_URL() + filePath;
    },

    baseUrl: function (path) {
        return BASE_URL() + '/' + (path || '');
    },

    // !!!DEPRECATED!!! Will not work in React app anymore.

    // Finds and returns label associated with a val of specific constant choice.
    // Third argument is default return value if val is falsey or collection/choice not found
    // Fourth argument is the name of an alternate label key in the choices collection
    getChoiceLabel: function (collectionName, val, defaultsTo, labelAlt) {
        defaultsTo = defaultsTo || '';

        var collection, choice, label;

        if (!val) {
            return defaultsTo;
        }

        label = labelAlt || 'label';

        collection = channel.request('constants:pick', collectionName);

        if (!collection) {
            throw Error(collectionName + ' not found!');
        }

        choice = collection.get('choices').findWhere({ val: val });

        if (!choice) {
            throw Error('No val ' + val + ' in ' + collectionName);
        }

        return choice.get(label) || defaultsTo;
    },

    //produces option elements for a select, optionally grouped into optgroups
    selectElChoices: function (choices, options) {
        options = options || {};

        if (options.alphabetize) {
            choices = _.sortBy(choices, 'label');
        }

        if (!options.key) {
            return _makeOptionsHelper(choices, options.alphabetize);
        }

        var groups = {};
        var groupOrder = [];

        _.each(choices, function (choice) {
            var val = choice[options.key];

            if (!_.has(groups, val)) {
                groups[val] = [];
                groupOrder.push(val);
            }

            groups[val].push(choice);
        });

        var template = _.template('<optgroup label="<%= label %>"><%= choices %></optgroup>');

        var order = options.groupOrder || groupOrder;

        var optgroups = _.reduce(
            order,
            function (memo, key) {
                if (groups[key]) {
                    var currentChoices = _makeOptionsHelper(groups[key]);
                    memo.push(template({ choices: currentChoices, label: key }));
                }
                return memo;
            },
            []
        );

        return optgroups.join('\n');
    },

    pluralize: function (itemName, count, plural, singular) {
        plural = plural || 's';
        singular = singular || '';

        if (count === 1) {
            return itemName + singular;
        }

        return itemName + plural;
    },

    formatNumber: function (value, format) {
        var numeralVal = numeral(value);

        if (!_.isNaN(numeralVal.value())) {
            format = format || '0,0[.]0[0]';
            return numeral(value).format(format);
        }
        return value;
    },

    linkify: function (text) {
        return linkify(text);
    },

    slugify: slugify,

    nl2br: function (text) {
        return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },

    formatDate: function (value, format) {
        format = format || 'MM-DD-YYYY';
        return moment(value).format(format);
    },

    // Escapes original input, then converts urls to links and new lines to <br>
    formatUserInput: function (text) {
        return globalHelpers.nl2br(globalHelpers.linkify(text));
    },

    simpleStripHTML: function (text) {
        return text.replace(/<\/?[^>]+(>|$)/g, '');
    },

    updatedAt: function (value, preposition) {
        var format = 'M/D/YYYY';
        var date = moment(value);

        if (moment().diff(date, 'days') < 1) {
            if (moment().diff(date, 'seconds') < 60) {
                return 'Just Now';
            }
            return date.fromNow();
        }
        var result = [moment(value).format(format)];

        if (preposition) {
            result.unshift(preposition);
        }

        return result.join(' ');
    },

    timeAgo: function (date) {
        return moment(date).fromNow();
    },

    formatSyndicationSites: function (syndication_sites) {
        if (syndication_sites.length) {
            return syndication_sites.join('</br>');
        }
        return 'Not currently syndicating to any sites';
    },

    prettyDateAvailable: function (date, options) {
        options = _.extend(
            {
                dateFormat: 'MMM D',
                availableNow: 'Immediate',
                blankValue: ' TBD',
            },
            options || {}
        );

        if (!date) {
            return options.blankValue;
        }

        date = moment(date);
        var today = new Date();

        if (date.isBefore(today)) {
            return options.availableNow;
        }

        return globalHelpers.formatDate(date, options.dateFormat);
    },

    prettyMediaCounts: function (photoCount, floorplanCount) {
        var text = [];

        if (photoCount) {
            text.push(photoCount + ' ' + globalHelpers.pluralize('Photo', photoCount));
        }
        if (floorplanCount) {
            text.push(floorplanCount + ' ' + globalHelpers.pluralize('Floorplan', floorplanCount));
        }
        return text.join(', ');
    },

    formatCurrency: function (value, format) {
        if (_.isNull(value)) {
            return value;
        }

        var numeralVal = numeral(value);

        if (!_.isNaN(numeralVal.value())) {
            format = format || '$0,0[.]00';
            return numeralVal.format(format);
        }
        return value;
    },

    formatCurrencyRange: function (min, max) {
        if (min && max) {
            return `${globalHelpers.formatCurrency(min)} - ${globalHelpers.formatCurrency(max)}`;
        } else if (min) {
            return globalHelpers.formatCurrency(min);
        } else if (max) {
            return globalHelpers.formatCurrency(max);
        }
        return null;
    },

    listingStatusClass: function (status) {
        var statusGroups = {
            available: channel.request('constants:groups:pick', 'unitStatusesAvailable'),
            pending: channel.request('constants:groups:pick', 'unitStatusesPending'),
            unavailable: channel.request('constants:groups:pick', 'unitStatusesUnavailable'),
        };

        var className = _.reduce(
            statusGroups,
            function (memo, group, currentClassName) {
                if (_.contains(group, status)) {
                    return 'status-' + currentClassName;
                }
                return memo;
            },
            '',
            this
        );

        return className;
    },

    formatDateAvailable: function (value) {
        var dateAvailable = moment(value);
        var today = moment();

        if (dateAvailable.isSameOrBefore(today)) {
            return 'Immediately';
        }

        return dateAvailable.format('MMMM D');
    },

    // removes time from date, so that things that happened yesterday,
    // but less than 24 hours ago still return 1 day ago and dates with times and without return the same amount
    daysAgoInexact: function (date) {
        const normalizedDate = moment(date).hours(0).minutes(0).seconds(0).milliseconds(0);
        return moment().diff(normalizedDate, 'days');
    },
};

module.exports = globalHelpers;
